import {
  Box,
  Button,
  Dialog,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Stack,
  TextField,
  Typography,
  useTheme,
} from "@mui/material";
import { DialogText, GeneralButtonLabel } from "../../data/texts";
import CloseIcon from "@mui/icons-material/Close";
import { VoidFunction } from "../../models/common.models";
import { WalletType } from "../../models/wallet-watchlist.models";
import { useState } from "react";

interface AddWalletDialogProps {
  isOpen?: boolean;
  onClose: VoidFunction;
  onSubmit: (formData: AddWalletFormData) => void;
}

enum AddWalletFormFields {
  WALLET_TYPE = "walletType",
  WALLET_ADDRESS = "walletAddress",
}

export interface AddWalletFormData {
  [AddWalletFormFields.WALLET_ADDRESS]: string;
  [AddWalletFormFields.WALLET_TYPE]: string;
}

const AddWalletDialog = ({
  isOpen,
  onClose,
  onSubmit,
}: AddWalletDialogProps) => {
  const walletTypes = Object.values(WalletType);
  const theme = useTheme();
  const [formData, setFormData] = useState<AddWalletFormData>({
    [AddWalletFormFields.WALLET_TYPE]: walletTypes[0],
    [AddWalletFormFields.WALLET_ADDRESS]: "",
  });

  const onChange = (field: string, value: string) => {
    setFormData({ ...formData, [field]: value });
  };

  return (
    <Dialog open={!!isOpen}>
      <Paper sx={{ width: "500px", height: "350px", padding: "15px" }}>
        <Stack alignItems={"center"}>
          <Box
            sx={{
              marginBottom: "30px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
            }}
          >
            <Typography
              sx={{ fontWeight: "500", fontSize: "20px", color: "black" }}
            >
              {DialogText.ADD_WALLET}
            </Typography>
            <Box onClick={onClose}>
              <CloseIcon sx={{ color: "black", cursor: "pointer" }} />
            </Box>
          </Box>
          <InputLabel
            sx={{
              alignSelf: "flex-start",
              fontWeight: "400",
              marginBottom: "5px",
            }}
          >
            {DialogText.WALLET_TYPE}
          </InputLabel>
          <Select
            sx={{
              ".MuiSelect-select": { fontWeight: "500" },
              width: "100%",
              marginBottom: "20px",
            }}
            value={formData.walletType}
          >
            {walletTypes.map((type) => (
              <MenuItem
                sx={{
                  paddingBlock: "10px",
                  fontWeight: "500 !important",
                }}
                onClick={() => onChange(AddWalletFormFields.WALLET_TYPE, type)}
                value={type}
                key={type}
              >
                {type}
              </MenuItem>
            ))}
          </Select>
          <InputLabel
            sx={{
              alignSelf: "flex-start",
              fontWeight: "400",
              marginBottom: "5px",
            }}
          >
            {DialogText.WALLET_ADDRESS}
          </InputLabel>
          <TextField
            onChange={(ev) =>
              onChange(AddWalletFormFields.WALLET_ADDRESS, ev.target.value)
            }
            sx={{
              width: "100%",
              marginBottom: "20px",
              input: { fontWeight: "500" },
            }}
          />
          <Button
            onClick={() => onSubmit(formData)}
            sx={{
              background: theme.palette.text.primary,
              color: "white",
              width: "50%",
            }}
          >
            {GeneralButtonLabel.SUBMIT}
          </Button>
        </Stack>
      </Paper>
    </Dialog>
  );
};

export default AddWalletDialog;
